
import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'

const TrainingSetups = lazy(() => import('./TrainingSetups'))

const TrainingRoutes = [
    {
        path: '/training_setups',
        component: TrainingSetups,
        auth:authRoleAccess.trainingSetups,
    },  
    
]

export default TrainingRoutes 